import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { DeadlineService } from '../../../../../services/deadline.service';
// import { DatepickerOptions } from 'ng2-datepicker';
import * as frLocale from 'date-fns/locale/fr';

import { DocumentMangService } from '../../../../../services/document_mang.service';


declare var $: any;

@Component({
  selector: 'app-document_mang_action',
  templateUrl: './document_mang_action.component.html',
  styleUrls: ['./document_mang_action.component.css']
})


export class DocumentMangActionComponent implements OnInit {

  @Input() ID: string; DID: string; action: string; 
  @Input() langs: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  modalTitle: string;

  lang: any;
  actionLang: any;
  record: any;
  mode: string;
  app_emp_id:any;

  imageLink: any;
  
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private documentmangService: DocumentMangService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.getData();
    this.FormBuild();

    this.config();
    this.fileDesign();
  }
  

  config(): void {
        
    this.typeConfig = [
      { value: 'Quality', text: 'description' },
      { value: 'Safety', text: 'Safety' },
      { value: 'Environment', text: 'Environment' },
      { value: 'Administration', text: 'Administration' },
      { value: 'Various', text: 'Various' },
    ];

  }

  FormBuild(): void {
    // console.log(this.DID);
  
    this.createForm = this.formBuilder.group({
      rev_date: ['', [Validators.required]],
      revision_code: ['', [Validators.required]],
      revision_discrp: ['', [Validators.required]],
      rev_written_by: ['', [Validators.required]],
      rev_verified_by: ['', [Validators.required]],
      rev_approved_by: ['', [Validators.required]],
      attachments: this.formBuilder.array([this.newAttachment()]),
      attachments_uploaded: this.formBuilder.array([]),
      doc_id: this.DID,
      intervention_id:'',
      action: 'document_intervention_update',
    });

    this.createFormErrorMsg = {
      'rev_date': [{ type: 'required', message: 'This field is Required' }],
      'revision_code': [{ type: 'required', message: 'This field is Required' }],
      'revision_discrp': [{ type: 'required', message: 'This field is Required' }],
      'rev_written_by': [{ type: 'required', message: 'This field is Required' }],
      'rev_verified_by': [{ type: 'required', message: 'This field is Required' }],
      'rev_approved_by': [{ type: 'required', message: 'This field is Required' }],
      'attachments': [
        { type: 'validExt', message: 'File format is not supported' }
      ],
    }

    setTimeout(() => this.fileDesign(), 10);

    this.attachments().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });
    

  }

  FormBuildUpdate(): void {

    let images = this.record.revision_attach.split(',');

    // console.log('this.record.execution_date');

    this.createForm.patchValue({
      rev_date: this.record.rev_date,
      revision_code: this.record.revision_code,
      revision_discrp: this.record.revision_discrp,
      rev_written_by: this.record.rev_written_by,
      rev_verified_by: this.record.rev_verified_by,
      rev_approved_by: this.record.rev_approved_by,
      doc_id: this.record.doc_id,
      intervention_id: this.record.intervention_id
    });


    if(this.record.revision_attach) {
      for (const image of images) {
        this.attachments_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }
    
    
    setTimeout(() => this.fileDesign(), 10);

  }


  FormBuildUpdate1(): void {

    let images = this.record.revision_attach.split(',');

    // console.log('this.record.execution_date');

    this.createForm.patchValue({
      rev_date: this.record.rev_date,
      revision_code: this.record.revision_code,
      revision_discrp: this.record.revision_discrp,
      rev_written_by: this.record.rev_written_by,
      rev_verified_by: this.record.rev_verified_by,
      rev_approved_by: this.record.rev_approved_by,
      doc_id: this.record.doc_id,
      intervention_id: ''
    });



    if(this.record.revision_attach) {
      for (const image of images) {
        this.attachments_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }
    
    
    setTimeout(() => this.fileDesign(), 10);

  }

 attachments(): FormArray {
    return this.createForm.get('attachments') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      // link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
      link: ['']
    });
  }

  addAttachment(): void {
    this.attachments().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.attachments().removeAt(i);
  }

  attachments_uploaded(): FormArray {
    return this.createForm.get('attachments_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.attachments_uploaded().removeAt(i);
  }
  
  public selectAttachment(event: any, index) {

    this.createForm.value.attachments[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
          this.createForm.value.attachments[index].link = {'name': file.name, 'image': reader.result};
      };
    }
    
  }

  fileDesign(){
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }

  onSubmit() {
    this.createFormSubmitted = true;
    if (this.createForm.invalid)
    {
      return;
    }
    
    this.documentmangService.update_revision(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();
          
          this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.DOCUMENTMANG_VIEW+'/'+this.DID]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

  getData() {
    // console.log(this.DID); return false;
    if (this.action == 'duplicate') {
      // console.log(this.action); return false;

      this.documentmangService.edit_action(this.ID,this.DID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }
          
          // this.lang = this.deadlineService.createLang(res);
          this.record = res.data;
          this.app_emp_id = res.data.emp_list;

          this.FormBuildUpdate1();
        }
      );
      this.actionLang = this.langs;

      this.mode = 'Edit';
      this.modalTitle = this.actionLang.status;
    }
    else if (this.ID) {
      // console.log(this.ID); return false;
      this.documentmangService.edit_action(this.ID,this.DID).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }

          // this.lang = this.deadlineService.createLang(res);
          this.record = res.data;
          this.app_emp_id = res.data.emp_list;

          this.FormBuildUpdate();
        }
      );
      this.actionLang = this.langs;

      this.mode = 'Edit';
      this.modalTitle = this.actionLang.status;
    }
    else {
     
      this.documentmangService.create(this.DID).subscribe(
      (res) => {
          this.app_emp_id = res.data.emp_list;
          }
      );

      // console.log(this.langs);

      this.actionLang = this.langs;
      this.mode = 'Create';
      this.modalTitle = this.actionLang.addRevision;
    }

  }

}
